import classNames from 'classnames';
import React from 'react';
import itemClasses from './Item.module.scss.js';
import ownClasses from './RecentSearches.module.scss.js';
import SuggestionResult from './SuggestionResult.js';
import areSameGeo from './areSameGeo.js';

const RecentSearches = ({ variant, getItemProps, highlightedIndex, searches, selectedItem, assetsBase, }) => {
    const [defaultOption, ...recentSearches] = searches;
    const highlightedIndices = searches.map((item, index) => highlightedIndex === index ||
        (selectedItem != null && areSameGeo(item.value, selectedItem.value)));
    const isSmall = variant === 'desktop';
    return (React.createElement(React.Fragment, null,
        React.createElement("li", { className: classNames(itemClasses.item, {
                [itemClasses['size-small']]: isSmall,
                [itemClasses.selected]: highlightedIndices[0],
            }), key: `${defaultOption.inputLabel}-default`, ...getItemProps({ item: defaultOption, index: 0 }) },
            React.createElement("img", { src: `${assetsBase}/static/icons/cactus/lens.svg`, width: "24", height: "24", alt: "" }),
            defaultOption.optionLabels),
        React.createElement("div", { className: ownClasses.title },
            React.createElement("p", { className: classNames('body-text', 'semibold', { small: isSmall }) }, "Ricerche recenti")),
        recentSearches.map((item, index) => (React.createElement("li", { className: classNames(itemClasses.item, {
                [itemClasses['size-small']]: isSmall,
                [itemClasses.selected]: highlightedIndices[index + 1],
            }), key: `${item.inputLabel}-${index + 1}`, ...getItemProps({ item, index: index + 1 }) },
            React.createElement("img", { src: `${assetsBase}/static/icons/cactus/clock.svg`, width: "16", height: "16", alt: "", className: ownClasses['item-icon'] }),
            React.createElement(SuggestionResult, { geoOptionsLabels: item.optionLabels }))))));
};

export { RecentSearches as default };
//# sourceMappingURL=RecentSearches.js.map
